// The save footer's footprint, for the lock banners that would cover it.
//
// The lock request banners (LockBanner) are position:fixed along the bottom of
// the window, above the tab strip, at zIndex 1300. The sidebar's save footer
// (SaveFooter) slides in at the bottom of the sidebar once a section is dirty,
// with Discard and Save at its LEFT edge. Where the two overlap, the banner
// sits over Discard and Save, and the clinician cannot save while a colleague
// is asking for the lock, which is exactly when they most need to:
//
//   - the person tab: the region is full width, and so is the banner.
//   - the drawer, PROMOTED: up to 1080px wide, while the banner only stops
//     400px from the right (the peek width). The Drawer's `zIndex: 2100` is
//     set on its docked root, which is not positioned, so it does not apply;
//     the fixed paper stacks at the theme's drawer zIndex (1200), below the
//     banner's 1300. (Read from the code and MUI's Drawer source, not
//     measured in a browser.)
//
// The peek drawer is 400px wide and the banner already ends at its left edge,
// so nothing there is covered and nothing moves.
//
// While a covered footer is showing, SaveFooter publishes its measured height
// under SAVE_FOOTER_OFFSET_VAR and removes it when the footer goes away; the
// banner adds it to the tab strip's offset. It is set on the TAB's container
// (PedigreeInstanceContext), not on <html> as the strip's is: every open tab is
// mounted, so a dirty footer in a hidden tab would otherwise lift the banner
// of the tab on screen. Custom properties inherit through the DOM, and the
// banner is rendered inside the tab's container, fixed positioning or not.
// Without a workspace (one chart) there is no container, and <html> is used.
//
// One module for the name and its reader, as tabBarOffset.js does and for the
// same reason: a misspelt custom property fails silently to its fallback.

export const SAVE_FOOTER_OFFSET_VAR = '--savefooter-offset';

export const SAVE_FOOTER_OFFSET = `var(${SAVE_FOOTER_OFFSET_VAR}, 0px)`;

// Used only when the footer has no measurable height (no layout yet, or no
// layout engine at all): the footer's height with the default theme, 10px of
// padding above and below a 36.5px medium button, plus its 1px top border.
export const SAVE_FOOTER_FALLBACK_HEIGHT = 58;

/**
 * Whether this sidebar's save footer would sit under the lock banners, and so
 * should publish its height. A person tab's region always; the drawer only
 * while it is open and promoted.
 */
export const saveFooterLiftsLockBanner = ({ isRegion, promoted, open }) =>
  !!isRegion || (!!promoted && !!open);
